<template>
  <b-container class="container-fluid">
    <div class="py-5 text-center">
      <h2>CSC2005 Event</h2>
    </div>
    <b-row>
      <b-col cols="12" md="6" lg="6" xl="6">
        <h3>Synopsis</h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
          velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
          occaecat cupidatat non proident, sunt in culpa qui officia deserunt
          mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur
          adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
          irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
          fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
          sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem
          ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
          ea commodo consequat. Duis aute irure dolor in reprehenderit in
          voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
          sint occaecat cupidatat non proident, sunt in culpa qui officia
          deserunt mollit anim id est laborum.
        </p>
      </b-col>
      <b-col cols="12" md="6" lg="6" xl="6">
        <h3>About Speaker</h3>
        <img
          src="../assets/profilepic.jpg"
          class="img-circle center"
          alt="Profile Picture"
          style="width: 100px; height: 100px"
        />
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
          velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
          occaecat cupidatat non proident, sunt in culpa qui officia deserunt
          mollit anim id est laborum.
        </p>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" order-md="1" md="6" lg="6" xl="6">
        <div class="map">
          <h3>Location Map</h3>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2371.6745811912306!2d103.84770272082076!3d1.3774907990615304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da16e96db0a1ab%3A0x3d0be54fbbd6e1cd!2sSingapore%20Institute%20of%20Technology%20(SIT%40NYP)!5e0!3m2!1sen!2ssg!4v1602670990163!5m2!1sen!2ssg"
            width="80%"
            height="400"
            frameborder="0"
            style="border: 0"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
          <h4>Singapore Institute of Technology</h4>
          <h4>172 Ang Mo Kio Avenue 8, 567739</h4>
          <h5>How to get here:</h5>
          <h5>
            By Train - Yio Chu Kang MRT Station, then take Exit B and walk for
            573m.
          </h5>
          <h5>By Bus - 45, 50, 72, 72A, 72B, 159, 159B</h5>
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="6" xl="6">
        <h3>Registration Form</h3>
        <ValidationObserver ref="observer">
          <b-form slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)">
            <ValidationProvider rules="required" name="First Name">
              <b-form-group
                label-align-md="left"
                slot-scope="{ valid, errors }"
                label="First Name"
              >
                <b-form-input
                  type="text"
                  v-model="user.firstname"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter first name (Required)"
                  ref="firstname"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required" name="Last Name">
              <b-form-group
                label-align-md="left"
                slot-scope="{ valid, errors }"
                label="Last Name"
              >
                <b-form-input
                  type="text"
                  v-model="user.lastname"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter last name (Required)"
                  ref="lastname"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required|email" name="Email">
              <b-form-group
                label-align-md="left"
                slot-scope="{ valid, errors }"
                label="Email"
              >
                <b-form-input
                  type="email"
                  v-model="user.email"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter email (Required)"
                  ref="email"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required" name="Mobile">
              <b-form-group
                label-align-md="left"
                slot-scope="{ valid, errors }"
                label="Mobile Number"
              >
                <b-form-input
                  type="number"
                  v-model="user.mobile"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter mobile number (Required)"
                  ref="mobile"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required" name="Main Address">
              <b-form-group
                label-align-md="left"
                slot-scope="{ valid, errors }"
                label="Address"
              >
                <b-form-input
                  type="text"
                  v-model="user.mainAddress"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter main address(Required)"
                  ref="mainAddress"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <b-form-group label-align-md="left" label="Address 2 (Optional)">
              <b-form-input
                type="text"
                v-model="user.secAddress"
                placeholder="Apartment of Suite"
                ref="secAddress"
              >
              </b-form-input>
            </b-form-group>

            <ValidationProvider rules="required" name="Nationality">
              <b-form-group
                label-align-md="left"
                slot-scope="{ valid, errors }"
                label="Nationality"
              >
                <b-form-select
                  :state="errors[0] ? false : valid ? true : null"
                  v-model="user.nationalitySelected"
                  ref="nationality"
                >
                  <b-form-select-option :value="null"
                    >Please select an option</b-form-select-option
                  >
                  <b-form-select-option value="Singaporean"
                    >Singaporean</b-form-select-option
                  >
                  <b-form-select-option value="Malaysian"
                    >Malaysian</b-form-select-option
                  ></b-form-select
                >
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required" name="Postal Code">
              <b-form-group
                label-align-md="left"
                slot-scope="{ valid, errors }"
                label="Postal Code"
              >
                <b-form-input
                  type="number"
                  v-model="user.postalCode"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter Postal Code(Required)"
                  ref="postalCode"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider name="Profession" rules="required">
              <b-form-group
                slot-scope="{ valid, errors }"
                label-align-md="left"
                label="Profession"
              >
                <b-form-select
                  :state="errors[0] ? false : valid ? true : null"
                  v-model="user.professionSelected"
                  ref="profession"
                >
                  <b-form-select-option :value="null"
                    >Please select an option</b-form-select-option
                  >
                  <b-form-select-option value="FrontEnd Engineer"
                    >FrontEnd Engineer</b-form-select-option
                  >
                  <b-form-select-option value="Underpaid Lab TA"
                    >Underpaid Lab TA</b-form-select-option
                  >
                  <b-form-select-option value="Others"
                    >Others</b-form-select-option
                  >
                </b-form-select>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <b-button type="submit" variant="primary">Submit</b-button>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: [
    "firstname",
    "lastname",
    "email",
    "mobile",
    "mainAddress",
    "secAddress",
    "nationalitySelected",
    "postalCode",
    "professionSelected",
  ],

  data() {
    return {
      user: {
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        mainAddress: "",
        secAddress: "",
        postalCode: "",
        nationalitySelected: null,
        professionSelected: null,
      }
    };
  },

  // computed: {
  //   name: function() {
  //     return this.user.firstname + ' ' + this.user.lastname
  //   }
  // },

  methods: {
    onSubmit(evt) {
      evt.preventDefault();

      console.log(JSON.stringify(this.user));

      this.user.firstname = this.$refs.firstname.value;
      this.user.lastname = this.$refs.lastname.value;
      this.user.email = this.$refs.email.value;
      this.user.mobile = this.$refs.mobile.value;
      this.user.mainAddress = this.$refs.mainAddress.value;
      this.user.secAddress = this.$refs.secAddress.value;
      this.user.postalCode = this.$refs.postalCode.value;
      this.user.nationalitySelected = this.$refs.nationality.value;
      this.user.professionSelected = this.$refs.profession.value;
      this.$emit("clicked", this.user);
      this.$router.push("/submissions");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


